module.exports = __webpack_public_path__ + "static/img/1.94f0234.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/1.png
// module id = Fh2J
// module chunks = 0